module.exports = __webpack_public_path__ + "static/media/android.a5e76440.png";